import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const CATALOG_SECTION_ENDPOINT = 'catalog-sections';
export const CATALOG_SECTION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CATALOG_SECTION_ENDPOINT);

export const catalogSectionStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}
